<div layout="row" class="full-height layout-row layout-align-start-center"
     [ngbTooltip]="tooltipTmpl" container="body" openDelay="300" triggers="hover">

  <span class="br-caption-2">{{packages | servicePackagesCount}}</span>

  <bringoz-icon iconName="package-outline" class="gray-102" [ngClass]="{'packed-color': isPacked}"></bringoz-icon>

  <ng-template #tooltipTmpl>
    <div layout="column" class="full-height layout-column">

      <div class="layout-column" *ngFor="let packageItem of packages; let last = last">

        <div layout="column" class="padding-5 layout-column">
          <div class="layout-row layout-align-start-center">
            <app-bringoz-package-item [id]="packageItem.size || packageItem.type"></app-bringoz-package-item>
            <span class="br-body-2 margin-left-5 font-weight-500">X{{packageItem.count}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="barcode" class="gray-102"></bringoz-icon>
            <span class="br-body-2 font-weight-400">{{packageItem.barcode || '---'}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="message-outline" class="gray-102"></bringoz-icon>
            <span class="br-body-2 font-weight-400">{{packageItem.description || '---'}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="weight" class="gray-102"></bringoz-icon>
            <span class="br-body-2 font-weight-400">{{packageItem.weight | bringozWeight:true:'---'}}</span>
          </div>

          <div class="layout-row layout-align-start-center"
               *ngIf="packageItem.dimensions">
            <bringoz-icon iconName="volume" class="gray-102"></bringoz-icon>
            <span class="br-body-2 font-weight-400">{{packageItem.dimensions | bringozDimensions:'---'}}</span>
          </div>

          <div class="layout-row layout-align-start-center">
            <bringoz-icon iconName="volume" class="gray-102"></bringoz-icon>
            <span class="br-body-2 font-weight-400">{{packageItem.volume | bringozVolume:true:'---'}}</span>
          </div>

          <div class="layout-row layout-align-start-center"
               *ngIf="packageItem.pallets">
            <bringoz-icon iconName="pallets" class="gray-102"></bringoz-icon>
            <span class="br-body-2 font-weight-400">{{packageItem.pallets}}</span>
          </div>


        </div>

        <hr *ngIf="!last" class="main-divider">

      </div>
    </div>

  </ng-template>

</div>
